import { useCallback, useState, useEffect } from "react"
import { BrowserRouter, Switch, Route, useHistory } from "react-router-dom"
import BackgroundGif from "./assets/back.gif"
import ROUTES from "./common/routes"
import { Patient } from "./common/types"
import ScheduleList from "./pages/ScheduleList"
import Home from "./pages/Home"
import MyReservationList from "./pages/MyReservationList"
import MakeAppointmentPage from "./pages/MakeAppointmentPage"
import ReservationDetail from "./pages/ReservationDetail"
import styled from "styled-components"
import { HOSPITAL_NAME } from "./common/constant"

export const Main = styled.div`
  background: url(${BackgroundGif});
  width: 100%;
  height: 100%;
  min-height: 100vh;
  fontFamily: "PingFang TC";
  `

function App() {
  const history = useHistory()
  const [patient, setPatient] = useState<Patient | null>(null)

  useEffect(() => {
    if (HOSPITAL_NAME) {
      document.title = `${HOSPITAL_NAME}線上預約系統`
    }
  }, [])

  const onLogin = useCallback(
    (data: Patient) => {
      setPatient(data)
      history.push(ROUTES.reservationList)
    },
    [history]
  )

  return (
    <Main>
      <Switch>
        <Route path={ROUTES.reservationList}>
          <MyReservationList patient={patient} />
        </Route>
        <Route path={ROUTES.scheduleList}>
          <ScheduleList patient={patient} />
        </Route>
        <Route path={ROUTES.makeAppointmentPage}>
          <MakeAppointmentPage patient={patient} />
        </Route>
        <Route path={ROUTES.reservationDetail}>
          <ReservationDetail patient={patient} />
        </Route>
        <Route path="/">
          <Home onLogin={onLogin} />
        </Route>
      </Switch>
    </Main>
  )
}

function AppWrapper() {
  return (
    <BrowserRouter>
      <App></App>
    </BrowserRouter>
  )
}

export default AppWrapper
